import RemoveOrderModal from './RemoveOrderModal';
export default RemoveOrderModal;
